module.exports = __webpack_public_path__ + "src/assets/img/guestlist_double_ma1.76dd0853.jpg";